// removed by extract-text-webpack-plugin
module.exports = {"CustomMarker":"CustomMarker__CustomMarker__19bNW","fadein":"CustomMarker__fadein__2RvXW"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/CustomMarker/CustomMarker.css
// module id = 253
// module chunks = 0